import React from "react";
import { Link } from "react-router-dom";
import { Paths } from "../../constants";
import Settings from "../../settings";
import { Report } from "../bug";

interface OwnProps {

}

interface OwnState {

}

export class Header extends React.Component<OwnProps, OwnState> {
    public render() {
        return (
            <div id="header">
                <div id="header-nav">
                    <ul>
                        <li><Report linkText="Report a problem" /></li>
                    </ul>
                </div>

                <div id="header-content">
                    <div id="logo">
                        <Link to={Paths.Home}>
                            <img alt={`${Settings.ClientName}`} src="/content/images/logo.png" />
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/Header.tsx